import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Eye, EyeOff } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard");
    } catch {
      setError("Email ou mot de passe incorrect");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1B2E4B] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-baseline justify-center gap-1 mb-1">
            <span className="text-white text-2xl font-bold tracking-tight">RM Location</span>
            <span className="text-[#D4A843] text-xs font-semibold tracking-[0.2em] ml-1">PRESTIGE</span>
          </div>
          <p className="text-slate-400 text-xs tracking-widest uppercase mt-1">Administration</p>
        </div>

        <div className="bg-white p-8 shadow-2xl rounded-sm">
          <h2 className="text-lg font-bold text-gray-900 mb-1">Connexion</h2>
          <p className="text-gray-400 text-sm mb-6">Accédez à votre espace d'administration</p>

          {error && (
            <div data-testid="login-error" className="bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-3 mb-4 rounded">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1.5 uppercase tracking-wider">Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                required placeholder="admin@rmlocation.re"
                data-testid="login-email"
                className="w-full border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-100 transition-colors rounded-sm" />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1.5 uppercase tracking-wider">Mot de passe</label>
              <div className="relative">
                <input type={showPwd ? "text" : "password"} value={password}
                  onChange={e => setPassword(e.target.value)} required
                  placeholder="••••••••"
                  data-testid="login-password"
                  className="w-full border border-gray-200 px-4 py-3 text-sm focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-100 pr-10 transition-colors rounded-sm" />
                <button type="button" onClick={() => setShowPwd(!showPwd)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                  {showPwd ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading} data-testid="login-submit"
              className="w-full py-3 bg-[#1B2E4B] text-white font-semibold tracking-wide hover:bg-[#162440] transition-colors disabled:opacity-60 mt-2 rounded-sm">
              {loading ? "Connexion en cours..." : "Se connecter"}
            </button>
          </form>
        </div>

        <div className="text-center mt-6">
          <a href="/" className="text-slate-400 text-xs hover:text-slate-200 transition-colors">
            ← Retour au site
          </a>
        </div>
      </div>
    </div>
  );
}
